import Typography from "@material-ui/core/Typography";

export const PageTitle = ({ title }) => (
  <Typography variant="h4" component="h1" style={{ marginBottom: 10 }} data-testid="page-title">
    { title}
  </Typography>
)
